<template>
  <q-table ref="tableRef" :rows="rows" :columns="columns" row-key="name" class="q-ma-md" v-model:pagination="pagination"
    :loading="loading" :filter="filter" @request="onRequest">
    <template v-slot:top-right>
      <q-input borderless dense debounce="300" v-model="filter" placeholder="Buscar">
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
    </template>
  </q-table>
</template>

<script setup>
import PresupuestoService from '@/services/PresupuestoService.js';
import { ref, onMounted } from 'vue';
const filter = ref('');
const tableRef = ref();
const loading = ref(false);
const pagination = ref({
  sortBy: 'id',
  descending: true,
  page: 1,
  rowsPerPage: 3,
  rowsNumber: 10,
  cliente: true,
});
const columns = [
  { name: 'id', label: 'ID', field: 'id', align: 'left', sortable: true },
  { name: 'referencia', label: 'Referencia', field: 'referencia', align: 'left', sortable: true },
  {
    label: 'Cliente',
    name: 'cliente',
    align: 'left',
    field: (row) => row?.cliente?.A1_NOME,
    sortable: true
  },
  { label: 'Direccion', name: 'direccion', align: 'left', field: 'direccion' },
  { label: 'Creado', name: 'created_at', align: 'left', field: 'created_at' },
  { label: 'Actualizado', name: 'updated_at', align: 'left', field: 'updated_at' },
  {
    label: 'Observaciones',
    name: 'observaciones',
    align: 'left',
    field: 'observaciones'
  }
];
const rows = ref([]);
const onRequest = async (props) => {
  const filter = props.filter;
  const { page, rowsPerPage, sortBy, descending } = props.pagination
  loading.value = true;

  const { data, per_page, current_page, total } = await PresupuestoService.index(
    { page, rowsPerPage, sortBy, descending, filter, cliente: true }
  );
  rows.value = data;
  console.log(data);
  pagination.value.rowsPerPage = per_page;
  pagination.value.page = current_page;
  pagination.value.rowsNumber = total;
  pagination.value.sortBy = sortBy
  pagination.value.descending = descending
  loading.value = false;
};
onMounted(() => {
  // get initial data from server (1st page)
  tableRef.value.requestServerInteraction();
});
</script>
